export default function About() {
  return (
    <section id="about" className="w-full bg-background-50">
      <div className="w-full px-6 md:px-10 lg:px-14 py-24 md:py-32">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <div className="lg:col-span-6">
            <div className="relative px-6 md:px-0">
              <div className="relative rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Warm%20editorial%20portrait%20of%20a%20dairy%20farmer%20in%20denim%20apron%20standing%20beside%20a%20gentle%20holstein%20cow%20in%20a%20softly%20lit%20modern%20wooden%20dairy%20barn%2C%20sunlight%20streaming%20through%20wooden%20slats%2C%20clean%20cream%20colored%20interior%2C%20fresh%20straw%20bedding%2C%20warm%20natural%20amber%20tones%2C%20cinematic%20soft%20lighting%2C%20highly%20realistic%20documentary%20farm%20photography%2C%20calm%20trustworthy%20atmosphere%2C%20muted%20film%20color%20palette%20with%20cream%20and%20green&width=1200&height=1400&seq=vef-about-farm-01&orientation=portrait"
                  alt="CCF Partner Farm"
                  className="w-full h-[400px] md:h-[560px] object-cover object-top"
                />
              </div>

              <div className="hidden md:block absolute -bottom-8 -right-6 md:-right-10 w-64 rounded-xl bg-background-50 border border-background-200 p-5">
                <div className="flex items-center gap-3">
                  <div className="w-11 h-11 flex items-center justify-center rounded-full bg-accent-500 text-background-50">
                    <i className="ri-award-line text-xl"></i>
                  </div>
                  <div>
                    <div className="text-xs text-foreground-600">2024 Global Agri Innovation</div>
                    <div className="text-sm font-semibold text-foreground-950">
                      Collaborative Platform of the Year
                    </div>
                  </div>
                </div>
                <div className="mt-4 flex items-center gap-2 text-xs text-foreground-600">
                  <i className="ri-verified-badge-line text-primary-500"></i>
                  3rd-Party Auditor Certified
                </div>
              </div>

              <div className="hidden md:block absolute -top-6 -left-6 md:-left-10 w-56 rounded-xl bg-primary-500 p-5 text-background-50">
                <div className="text-xs tracking-widest uppercase opacity-80">
                  Real-time
                </div>
                <div className="mt-2 flex items-baseline gap-1">
                  <span
                    className="text-4xl font-heading font-semibold"
                    style={{ fontFamily: "Fraunces, serif" }}
                  >
                    12,480
                  </span>
                  <span className="text-sm opacity-80">L / Today</span>
                </div>
                <div className="mt-1 text-xs opacity-90">
                  Today's Partner Farm Milk Production
                </div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-6">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-100 text-primary-800 text-xs font-semibold tracking-wide">
              <i className="ri-leaf-line"></i>
              About CCF
            </div>

            <h2
              className="mt-5 text-4xl md:text-5xl font-heading font-semibold tracking-tight text-foreground-950 leading-tight"
              style={{ fontFamily: "Fraunces, serif" }}
            >
              A Global Online Dairy Community for <span className="text-primary-600">Farming Enthusiasts</span>
            </h2>

            <p className="mt-6 text-base md:text-lg text-foreground-700 leading-relaxed">
              CCF brings together dairy farming enthusiasts from 96 countries, partnering with premium dairy farms worldwide. We believe farming shouldn't be lonely or inaccessible — through diversified allocation, we reduce risk and return the majority of profits to you.
            </p>

            <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-6">
              {[
                {
                  icon: "ri-scales-3-line",
                  title: "Diversified · Stability First",
                  desc: "Capital spread across multiple farms and regions, operating in sync.",
                },
                {
                  icon: "ri-hand-heart-line",
                  title: "Returns to Members",
                  desc: "80% of net profits distributed to online members, fully transparent.",
                },
                {
                  icon: "ri-earth-line",
                  title: "Global Farm Network",
                  desc: "Operations across 4 continents, natural climate and market cycle hedging.",
                },
                {
                  icon: "ri-team-line",
                  title: "Win-Win Community",
                  desc: "Member club, farm visit days, quarterly shared reports.",
                },
              ].map((item) => (
                <div
                  key={item.title}
                  className="p-5 rounded-xl border border-background-200 bg-background-100/50"
                >
                  <div className="w-10 h-10 flex items-center justify-center rounded-md bg-primary-500 text-background-50">
                    <i className={`${item.icon} text-lg`}></i>
                  </div>
                  <div className="mt-4 text-base font-semibold text-foreground-950">
                    {item.title}
                  </div>
                  <div className="mt-1.5 text-sm text-foreground-700 leading-relaxed">
                    {item.desc}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}